import { TPaymentStore } from "../features/user/user.types";

export const isStoreManagedSubscription = (
  store: TPaymentStore | null | undefined,
): store is "APP_STORE" | "PLAY_STORE" =>
  store === "APP_STORE" || store === "PLAY_STORE";

export const getPaymentStoreDisplayName = (
  store: TPaymentStore | null | undefined,
): string => {
  if (store === "PLAY_STORE") return "Google Play";
  if (store === "APP_STORE") return "the App Store";
  return "the web";
};
